import { useMemo, useState } from "react";
import { MEDIA, type MediaType } from "@/mocks/media";
import MediaCard from "@/components/base/MediaCard";
import SectionHeading from "@/components/base/SectionHeading";

const TABS: { label: string; value: MediaType | "all" }[] = [
  { label: "综合热榜", value: "all" },
  { label: "电影", value: "movie" },
  { label: "电视剧", value: "series" },
  { label: "综艺", value: "variety" },
];

export default function HotMedia() {
  const [tab, setTab] = useState<MediaType | "all">("all");

  const items = useMemo(() => {
    const list = tab === "all" ? MEDIA : MEDIA.filter((item) => item.type === tab);
    return [...list].sort((a, b) => b.views - a.views).slice(0, 12);
  }, [tab]);

  return (
    <section>
      <SectionHeading
        title="热门影视推荐"
        subtitle="按热度与评分精选，大家都在看"
        moreLink={tab === "all" ? "/category/movie" : `/category/${tab}`}
      />

      <div className="mb-6 inline-flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
        {TABS.map((item) => (
          <button
            key={item.value}
            type="button"
            onClick={() => setTab(item.value)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              tab === item.value
                ? "bg-primary-600 text-background-50"
                : "text-foreground-600 hover:text-primary-600"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}